import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { styled } from "@mui/material";

const StyledDialog = styled(Dialog)`
  user-select: none;
`;

const ConfirmationDialog = ({
  title,
  message,
  open,
  onCanceled,
  onConfirmed,
}) => {
  return (
    <StyledDialog
      open={open}
      onClose={onCanceled}
    >
      <DialogTitle>
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCanceled}>Cancel</Button>
        <Button onClick={onConfirmed} autoFocus>
          Confirm
        </Button>
      </DialogActions>
    </StyledDialog>
  );
};

export default ConfirmationDialog;